import { mapState } from 'vuex';
import createAxiosInstance from './interceptor';

export default {
  data: function () {
    return {
      toasted_options: {
        success: {
          position: 'top',
          type: 'success',
        },
        error: {
          position: 'top',
          type: 'error',
        },
        info: {
          duration: 8000,
          icon: 'info',
          iconPack: 'fontawesome',
          position: 'top-right',
          type: 'info',
          singleton: true,
        },
      },
      axiosInstance: null,
      currentUserId: null,
      orgInfo: null,
    };
  },
  async created() {
    this.axiosInstance = createAxiosInstance(this);
  },
  computed: {
    ...mapState('profile', [
      'userPermissions',
      'currentUser',
      'currentCoach',
      'organization',
    ]),
    ...mapState('programMgmt', ['program_management_permission']),
    validUser() {
      return this.currentUser ? this.currentUser : { active_member: {} };
    },
    activePermissionsByName() {
      return (this.userPermissions || []).reduce((permissions, permission) => {
        if (permission.active) {
          permissions[permission.name] = permission;
        }
        return permissions;
      }, {});
    },
    canAddEditProgram() {
      return this.activePermissionsByName['Can add/edit programs'];
    },
    canDeleteProgram() {
      return this.activePermissionsByName['Can delete programs'];
    },
    canAddEditBilling() {
      return this.activePermissionsByName['Can add/edit billing'];
    },
    canEditOrgSettings() {
      return this.activePermissionsByName['Can edit organizations settings'];
    },
    canAccessAppSettings() {
      return (
        !(
          this.organization?.super_organization_id ||
          this.organization?.is_super
        ) && this.activePermissionsByName['Can access App Store']
      );
    },
    canAddEditMetrics() {
      return this.activePermissionsByName['Can add/edit metrics'];
    },
    canAddEditResources() {
      return this.activePermissionsByName['Can add/edit resources'];
    },
    webEnvUrl() {
      let url = window.location.href;
      let envUrl = url.replace(window.location.pathname, '').replace('#/', '');
      return envUrl;
    },
  },
  methods: {
    async authenticate(func) {
      try {
        const response = await func.call();
        // This is for a redirect, but the data will not exist from server side authentication
        return response;
      } catch (e) {
        console.log(e);
        console.log(JSON.stringify(e));
        //window.location.href = '/';
      }
    },
    async getCurrentUserId() {
      try {
        const response = await this.axiosInstance.get(
          this.sessionUrl + 'get_current_user_id'
        );
        this.currentUserId = response.data.result;
      } catch (error) {
        console.error('Failed to get current user ID:', error);
        // Fallback: try to get ID from currentUser if available
        if (this.currentUser && this.currentUser.id) {
          this.currentUserId = this.currentUser.id;
        }
      }
    },
    async getCurrentCoach() {
      if (this.currentCoach) {
        return;
      }
      const response = await this.axiosInstance.get(
        this.sessionUrl + 'get_current_coach'
      );
      this.$store.commit('profile/setCurrentCoach', response.data.result);
    },
    async getCurrentUser() {
      if (this.currentUser) {
        return;
      }
      try {
        const response = await this.axiosInstance.get(
          this.sessionUrl + 'get_current_user'
        );
        this.$store.commit('profile/setCurrentUser', response.data.result);
      } catch (error) {
        console.error('Failed to get current user:', error);
      }
    },
    async getUserPermissions() {
      if (this.$store.state.profile.pageBootstrapLoaded) return;
      const response = await this.authenticate(async () => {
        return await this.axiosInstance.get(
          this.userUrl + 'get_user_permissions'
        );
      });
      this.$store.commit('profile/setUserPermissions', response.data.result);
    },
    async getProgramManagementPermissions() {
      if (this.$store.state.profile.pageBootstrapLoaded) return;
      let response = await this.axiosInstance.get(
        this.organizationSettingsUrl + 'get_permission/program_management'
      );
      this.$store.commit(
        'programMgmt/setProgramManagmentPermission',
        response.data.result
      );
    },
    async getWorkoutsPermission() {
      if (this.$store.state.profile.pageBootstrapLoaded) return;
      try {
        const response = await this.axiosInstance.get(
          this.organizationSettingsUrl + 'get_permission/workouts'
        );
        this.$store.commit(
          'profile/setWorkoutsPermission',
          response.data.result
        );
      } catch (error) {
        console.error('Failed to get workouts permission:', error);
        this.$store.commit('profile/setWorkoutsPermission', false);
      }
    },
    async getSettings() {
      let response = await this.axiosInstance.get(this.settingsUrl + 'first');
      return response.data.result;
    },
    hasCommunitySettings(user) {
      return user && user.has_communities_setting;
    },
    showResponse(
      response,
      successMessage,
      errorMessage,
      isSuccessPositive = true
    ) {
      if (response.data.success) {
        let options = this.toasted_options.success;
        options = {
          ...options,
          icon: 'check-circle',
          closeOnSwipe: true,
          duration: 2000,
        };
        !isSuccessPositive
          ? (options = { ...options, icon: 'times-circle', type: 'error' })
          : 0;
        this.$toast.show(
          successMessage ? successMessage : 'Save Successful',
          options
        );
      } else {
        this.$toast.show(
          errorMessage ? errorMessage : 'Error Saving',
          this.toasted_options.error
        );
      }
    },
  },
};
